const HIDDEN_STATUSES = new Set([
	"completed",
	"canceled",
	"closed",
	"duplicate",
])

export function isHiddenFromRequestList(issue: { status: string }) {
	return HIDDEN_STATUSES.has(issue.status)
}
